import { motion } from "framer-motion";
import { Stethoscope, HeartPulse, LineChart, Radio, Briefcase } from "lucide-react";
import { AUDIENCE } from "@/constants/summit";
import { Reveal, SectionHeading } from "@/components/Reveal";

const ICONS = { Stethoscope, HeartPulse, LineChart, Radio, Briefcase };

const Audience = () => (
  <section id="audience" data-testid="audience-section" className="relative py-24 sm:py-32 bg-charcoal/40">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        index="02"
        kicker="Who Attends"
        title={<>Strictly VVIP.<br className="hidden sm:block" /> Strictly by invitation.</>}
      />
      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {AUDIENCE.map((a, i) => {
          const Icon = ICONS[a.icon];
          return (
            <motion.div
              key={a.id}
              data-testid={`audience-tab-${a.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -8, transition: { type: "spring", stiffness: 300, damping: 20 } }}
              className="group relative rounded-2xl border border-white/10 bg-obsidian p-6 overflow-hidden"
            >
              <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-brand-500 to-brand-300 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-500/12 border border-brand-500/25 text-brand-400 transition-colors duration-300 group-hover:bg-brand-500 group-hover:text-white">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-5 font-display text-lg font-semibold leading-snug">{a.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55">{a.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export { Reveal };
export default Audience;
